import { z } from "zod";
import { TokenDataAliasSchema, tokenAliasOrValue } from "./base";
import { OpacityTokenData } from "./opacity";

export const ColorValue = z.object({
  opacity: OpacityTokenData,
  color: z.string().or(TokenDataAliasSchema),
});

export const ColorTokenData = tokenAliasOrValue(ColorValue);

export type ColorValue = z.infer<typeof ColorValue>;
export type ColorTokenData = z.infer<typeof ColorTokenData>;
